import { SYSTEM_ROLES_MAP, SYSTEM_ADMINISTRATOR_ROLE_NAMES } from "../constants/role.const.js";
import { Locale } from "../i18n/translatable.js";
import { CommonSchemaIds } from "./common.const.js";
import { InputType } from "./schema.types.js";
import { schemaId } from "./schemas.js";
export const COMMON_TLMD_SCHEMAS = {
    [CommonSchemaIds.UUID]: {
        id: CommonSchemaIds.UUID,
        schema: {
            type: 'string',
            pattern: '^[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12}$',
            default: '00000000-0000-0000-0000-000000000000',
        },
        input: {
            type: InputType.Hidden,
        },
    },
    [CommonSchemaIds.NAME]: {
        id: CommonSchemaIds.NAME,
        schema: {
            type: 'string',
            minLength: 4,
            maxLength: 20,
            pattern: '^[a-z0-9_\\-]{4,20}$',
            default: 'name',
        },
        input: {
            type: InputType.Hidden,
        },
    },
    [CommonSchemaIds.TITLE]: {
        id: CommonSchemaIds.TITLE,
        schema: {
            type: 'string',
            minLength: 4,
            maxLength: 50,
            pattern: '^[a-zA-Z0-9][\\w .,?+#*^%!=&@\\-()]{3,50}$',
            default: 'A Title',
        },
        input: {
            type: InputType.TextField,
        },
    },
    [CommonSchemaIds.LOCALE]: {
        id: CommonSchemaIds.LOCALE,
        schema: {
            type: 'string',
            default: Locale.en,
        },
        enum: Object.values(Locale),
        input: {
            type: InputType.SelectField,
            properties: {
                transform: 'uppercase',
            },
        },
    },
    [CommonSchemaIds.UUID_LIST]: {
        id: CommonSchemaIds.UUID_LIST,
        schema: {
            type: 'array',
            items: {
                $ref: schemaId(CommonSchemaIds.UUID),
            },
            default: ['00000000-0000-0000-0000-000000000000'],
        },
        input: {
            type: InputType.SelectField,
        },
    },
    [CommonSchemaIds.SYSTEM_ADMIN_ROLES]: {
        id: CommonSchemaIds.SYSTEM_ADMIN_ROLES,
        schema: {
            type: 'string',
            default: SYSTEM_ROLES_MAP[SYSTEM_ADMINISTRATOR_ROLE_NAMES[0]]._id,
        },
        enum: SYSTEM_ADMINISTRATOR_ROLE_NAMES.map((roleName) => SYSTEM_ROLES_MAP[roleName]._id),
        input: {
            type: InputType.SelectField,
        },
    },
    [CommonSchemaIds.ROLE]: {
        id: CommonSchemaIds.ROLE,
        schema: {
            type: 'string',
            default: '00000000-0000-0000-0000-000000000000',
        },
        input: {
            type: InputType.SelectField,
        },
    },
    [CommonSchemaIds.ROLES]: {
        id: CommonSchemaIds.ROLES,
        schema: {
            type: 'array',
            items: {
                $ref: schemaId(CommonSchemaIds.UUID),
            },
            default: ['00000000-0000-0000-0000-000000000000'],
        },
        input: {
            type: InputType.SelectField,
        },
    },
    [CommonSchemaIds.RESELLER]: {
        id: CommonSchemaIds.RESELLER,
        schema: {
            type: 'string',
            default: '00000000-0000-0000-0000-000000000000',
        },
        input: {
            type: InputType.SelectField,
        },
    },
    [CommonSchemaIds.DOMAIN]: {
        id: CommonSchemaIds.DOMAIN,
        schema: {
            type: 'string',
            default: '00000000-0000-0000-0000-000000000000',
        },
        input: {
            type: InputType.SelectField,
        },
    },
    [CommonSchemaIds.DOMAIN_ADMINISTRATORS]: {
        id: CommonSchemaIds.DOMAIN_ADMINISTRATORS,
        schema: {
            type: 'array',
            items: {
                $ref: schemaId(CommonSchemaIds.UUID),
            },
            default: ['00000000-0000-0000-0000-000000000000'],
        },
        input: {
            type: InputType.SelectField,
        },
    },
    [CommonSchemaIds.ACTIVE]: {
        id: CommonSchemaIds.ACTIVE,
        schema: {
            type: 'boolean',
            default: 'true',
        },
        input: {
            type: InputType.CheckField,
        },
    },
    [CommonSchemaIds.DELETED]: {
        id: CommonSchemaIds.DELETED,
        schema: {
            type: 'boolean',
            default: false,
        },
        input: {
            type: InputType.CheckField,
        },
    },
    [CommonSchemaIds.EMAIL]: {
        id: CommonSchemaIds.EMAIL,
        schema: {
            type: 'string',
            minLength: 6,
            pattern: '^[\\w\\.-]+@([\\w-]+\\.)+[\\w-]{2,4}$', //a really simple check to hopefully avoiding nasty injection stuff
            default: 'name@example.com',
        },
        input: {
            type: InputType.TextField,
        },
    },
    [CommonSchemaIds.SECRET]: {
        id: CommonSchemaIds.SECRET,
        schema: {
            type: 'string',
            minLength: 5,
            default: '********',
        },
        input: [
            {
                type: InputType.PasswordField,
                properties: {
                    visible: 'last',
                },
            },
            {
                type: InputType.RetypePasswordField,
                properties: {
                    visible: 'last',
                },
            },
        ],
    },
    [CommonSchemaIds.JWT]: {
        id: CommonSchemaIds.JWT,
        schema: {
            type: 'string',
            pattern: '^([a-zA-Z0-9_=]+)\\.([a-zA-Z0-9_=]+)\\.([a-zA-Z0-9_\\-\\+\\/=]*)$',
            default: 'some.access.token',
        },
    },
    [CommonSchemaIds.BEARER_TOKEN]: {
        id: CommonSchemaIds.BEARER_TOKEN,
        schema: {
            type: 'string',
            pattern: '^Bearer ([a-zA-Z0-9_=]+)\\.([a-zA-Z0-9_=]+)\\.([a-zA-Z0-9_\\-\\+\\/=]*)$',
            default: 'Bearer some.access.token',
        },
    },
};
